<div class="header">
    <p-button icon="pi pi-times" styleClass="p-button-rounded p-button-outlined p-button-sm p-button-secondary"
        (click)="close()"></p-button>
</div>

<iframe *ngIf="pdfUrl" [src]="pdfUrl" style="width: 100%; height: 82vh; border: none;" type="application/pdf">
    <!-- <button onclick="close()">Cerrar</button> -->
</iframe>